import iconEn from "../img/language/en.svg"
import iconDe from "../img/language/de.svg"

const data = {
    'en':
    {
        'index': { name: 'Index', href: '/' },
        'choirleader': { name: 'Choirleader', href: '/choirleader' },
        'arrangements': { name: 'Arrangements', href: '/arrangements' },
        'vocalcoach': { name: 'Vocalcoach', href: '/vocalcoach' },
        'contact': { name: 'Contact', href: '/contact' },
        'bio': { name: 'Bio', href: '/bio' },
        'projects': { name: 'Projects', href: '/projects' },
        'otherLanguageIcon': iconDe,
    },
    'de': {
        'index': { name: 'Index', href: '/de' },
        'choirleader': { name: 'Chorleiter', href: '/de/choirleader' },
        'arrangements': { name: 'Arrangements', href: '/de/arrangements' },
        'vocalcoach': { name: 'Workshops', href: '/de/vocalcoach' },
        'contact': { name: 'Kontakt', href: '/de/contact' },
        'bio': { name: 'Bio', href: '/de/bio' },
        'projects': { name: 'Projekte', href: '/de/projects' },
        'otherLanguageIcon': iconEn,
    },
}

export default data;